import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    user: null,
    userOptions: {},
    error: null,
    loading: false,
    authRedirectPath: '/',
    logout: false,
    checkSession: false
};

const authStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const authSuccess = (state, action) => {
    const { ...uData } = action.user.data;
    const permission = action.user.g.udo;
    //NLW-Exhibition BEGIN
    // Restriction for user lvl 1 - 4 >> no access to publishing panel
    // Code removed - set by database
    //if (process.env.REACT_APP_APPID == 'nlw') {
    //    permission.distributions.push({ name: 'NLW Exhibition' });
    //}
    //NLW-Exhibition END
    let user = { ...uData, usergroups: { ...action.user.data.usergroups }, email: action.user.email, permission: permission, originalObject: action.user, granting: action.user.g };
    return updateObject(state, {
        user: updateObject(state.user, user), loading: false
    });
}

const authFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const authLogout = (state, action) => {
    return updateObject(state, { user: null, logout: action.logout });
};
const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state, action);
        //case actionTypes.AUTH_SESSION_LOGIN_START: return updateObject(state, { checkSession: true });
        //case actionTypes.AUTH_SESSION_LOGIN_SUCCESS: return updateObject(state, { checkSession: false });
        //case actionTypes.AUTH_SESSION_LOGIN_FAIL: return updateObject(state, { checkSession: false });
        //case actionTypes.AUTH_SWITCH_GROUP_START: return updateObject(state, { loading: true });
        //case actionTypes.AUTH_SWITCH_GROUP_SUCCESS: return updateObject(state, { /*loading: false,*/ sessionChecked: false, user: null });
        //case actionTypes.AUTH_SWITCH_GROUP_FAIL: return updateObject(state, { loading: false, user: null });
        default:
            return state;
    }
}

export default reducer;
